import {PagerSettings} from '@progress/kendo-angular-grid';

export const GridPaginationConfig: PagerSettings = {
  info: true, pageSizes: true
};
